import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';

import {
    LotComponent,
    LotDeleteDialogComponent,
    LotDeletePopupComponent,
    LotDetailComponent,
    LotDialogComponent,
    LotPopupComponent,
    LOT_POPUP_ROUTES,
    LotPopupService,
    LotResolvePagingParams,
    LOT_ROUTES,
} from './';
import { LotCreateDialogComponent, LotCreatePopupComponent } from './lot-create-dialog.component';
import { LotUpdateDialogComponent, LotUpdatePopupComponent } from './lot-update-dialog.component';
import { LotImportDialogComponent, LotImportPopupComponent } from './lot-import-dialog.component';
import { LotWithdrawalDialogComponent, LotWithdrawalPopupComponent } from './lot-withdrawal-dialog.component';
import { LotDepositDialogComponent, LotDepositPopupComponent } from './lot-deposit-dialog.component';
import { LotBalanceAdjustmentDialogComponent, LotBalanceAdjustmentPopupComponent } from './lot-balance-adjustment-dialog.component';
import { LotImportDepositDialogComponent, LotImportDepositPopupComponent } from './lot-import-deposit-dialog.component';
import { LotImportDepositMappingDialogComponent } from './lot-import-deposit-mapping.dialog.component';
import { LotImportUpdateDialogComponent, LotImportUpdatePopupComponent } from './lot-import-update-dialog.component';
import { LotMergeDialogComponent, LotMergePopupComponent } from './lot-merge-dialog.component';
import { LotSplitDialogComponent, LotSplitPopupComponent } from './lot-split-dialog.component';
import { LotColumnsComponent } from './columns/lot-columns.component';
import { LotImportUpdateDescriptorsConfirmationDialogComponent } from './lot-import-update-descriptors-confirmation-dialog.component';
import { LotImportUpdateBalanceDialogComponent, LotImportUpdateBalancePopupComponent } from './lot-import-update-balance-dialog.component';
import { LotImportUpdateBalanceMappingDialogComponent } from './lot-import-update-balance-mapping.dialog.component';
import { BmsjHipsterSharedCommonModule, BmsjHipsterSharedModule } from '../../shared';
import { TabRouteGuard } from '../../inventory-manager/tab-route.guard';
import { LotDetailContext } from '../lot-detail/lot-detail.context';
import { LotService } from '../../shared/inventory/service/lot.service';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';
import { StorageLocationsSelectComponent } from '../../shared/location-inventory-storage/select/storage-locations-select.component';
import { SelectionCountComponent } from '../../shared/selection-count/selection-count.component';

const ENTITY_STATES = [
    ...LOT_ROUTES,
    ...LOT_POPUP_ROUTES,
];

@NgModule({
    imports: [
        RouterModule.forChild(ENTITY_STATES),
        BmsjHipsterSharedModule,
        TruncateSpanComponent,
        StorageLocationsSelectComponent,
        SelectionCountComponent,
        RouterLink,
    ],
    declarations: [
        LotComponent,
        LotColumnsComponent,
        LotCreateDialogComponent,
        LotBalanceAdjustmentDialogComponent,
        LotDetailComponent,
        LotDialogComponent,
        LotDeleteDialogComponent,
        LotUpdateDialogComponent,
        LotImportDialogComponent,
        LotImportUpdateDialogComponent,
        LotImportUpdateBalanceMappingDialogComponent,
        LotWithdrawalDialogComponent,
        LotDepositDialogComponent,
        LotImportDepositDialogComponent,
        LotImportDepositMappingDialogComponent,
        LotMergeDialogComponent,
        LotSplitDialogComponent,
        LotImportUpdateDescriptorsConfirmationDialogComponent,
        LotImportUpdateBalanceDialogComponent,
        LotPopupComponent,
        LotDeletePopupComponent,
        LotCreatePopupComponent,
        LotUpdatePopupComponent,
        LotImportPopupComponent,
        LotImportUpdatePopupComponent,
        LotImportUpdateBalancePopupComponent,
        LotWithdrawalPopupComponent,
        LotDepositPopupComponent,
        LotBalanceAdjustmentPopupComponent,
        LotImportDepositPopupComponent,
        LotMergePopupComponent,
        LotSplitPopupComponent,
    ],
    providers: [
        LotService,
        LotPopupService,
        LotResolvePagingParams,
        TabRouteGuard,
        LotDetailContext
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InventoryManagerLotModule {}
